import { render } from "./GalleryCarousel.vue?vue&type=template&id=568bb1e8&scoped=true"
import script from "./GalleryCarousel.vue?vue&type=script&lang=js"
export * from "./GalleryCarousel.vue?vue&type=script&lang=js"

import "./GalleryCarousel.vue?vue&type=style&index=0&id=568bb1e8&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-568bb1e8"],['__file',"src/scripts/sections/modules/gallery/GalleryCarousel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "568bb1e8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('568bb1e8', __exports__)) {
    api.reload('568bb1e8', __exports__)
  }
  
  module.hot.accept("./GalleryCarousel.vue?vue&type=template&id=568bb1e8&scoped=true", () => {
    api.rerender('568bb1e8', render)
  })

}


export default __exports__